import { createFileRoute } from "@tanstack/react-router";
import Backgammon from "@/containers/Backgammon";
import { GameValidateSearch } from "@/helpers";

export const Route = createFileRoute("/backgammon/$token/$matchID")({
	validateSearch: GameValidateSearch,
	component: () => <Backgammon />,
});
